import {observer} from "mobx-react-lite"
import React, {useEffect} from "react"
// import priceUpdateController from "../../store/pageControllers/PriceUpdateController"
import CliApi from "../../api/CliApi"
import {TaskControls} from "../../components/task_buttons/TaskControls";
import controller from "../../store/pageControllers/StockSettingsController"
import {SkeletonBox, WaCheckbox} from "../../lib/wa-2.0"
import ReactPaginate from "react-paginate"


export const StockUpdateLauncher = observer(() => {
    // useEffect(() => {
    //     controller.loadSettings()
    // }, [])

    return <div className={"custom-mt-32"} id={'price_markup'}>


        <div className={"custom-mt-20 "}>
            <div className={"custom-mb-12"}>Для обновления остатков по загруженным в Ozon и сопоставленным товарам, добавьте команду в CRON или запустите вручную:
            </div>
            <TaskControls command={controller.syncProducts} start={CliApi.runDownloadExportedProducts}/>
        </div>


    </div>
})